// Component for handling PDF file uploads and processing

import React from 'react';
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
} from '@react-pdf/renderer';

// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

const PDFFile = ({
  reportData,
  pdfURL,
  startDate,
  endDate,
}) => {
  return (
    // Connect to reports API and fetch data for PDF generation

    <Document
      key={Date.now()}
      options={{ disableWorker: true }}
      file={pdfURL()}
    >
      <Page
        style={styles.body}
        size="A4"
      >
        <View>
          <View
            style={
              styles.headerContainer
            }
          >
            <Text style={styles.title}>
              Tickets Activity Report
            </Text>
            <View
              style={
                styles.dateRangeView
              }
            >
              <Text
                style={
                  styles.dateRangeText
                }
              >
                {`From ${startDate} to ${endDate}`}
              </Text>
            </View>
          </View>
          <View
            style={styles.tableHeader}
          >
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Ticket
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Section
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Lane
            </Text>

            <Text
              style={
                styles.tableHeaderText
              }
            >
              Space
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Date In
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Time In
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Date Out
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Time Out
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Car Make
            </Text>
            <Text
              style={
                styles.tableHeaderText
              }
            >
              Car Color
            </Text>
          </View>
          {reportData.map((item) => (
            <View
              key={item.id}
              style={styles.tableHeader}
            >
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.Ticket}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.SectionName}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.LaneNum}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.SpaceNum}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {new Date(
                    item.DateTimeIn,
                  ).toLocaleDateString()}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {new Date(
                    item.DateTimeIn,
                  ).toLocaleTimeString()}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {new Date(
                    item.DateTimeOut,
                  ).toLocaleDateString()}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {new Date(
                    item.DateTimeIn,
                  ).toLocaleTimeString()}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.CarMake}
                </Text>
              </View>
              <View
                style={
                  styles.tableHeader
                }
              >
                <Text
                  style={styles.pdfText}
                >
                  {item.CarColor}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 10,
  },
  title: {
    fontSize: '24px',
    textAlign: 'center',
    color: 'black',
    textDecoration: 'underline',
    marginBottom: 5,
  },
  dateRangeView: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 10,
    marginBottom: 5,
  },
  dateRangeText: {
    width: '300px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 14,
    textDecoration: 'underline',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
  },
  tableHeaderText: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: 'black',
    padding: '2px',
    paddingBottom: '2px',
    textAlign: 'center',
    width: '100px',
    textDecoration: 'underline',
  },
  pdfText: {
    fontSize: '9px',
    textAlign: 'center',
    color: 'black',
    padding: '2px',
    width: '100px',
  },
  header: {
    fontSize: 22,
    marginBottom: 20,
    textAlign: 'center',
    color: 'black',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});
export default PDFFile;
